import PropTypes from "prop-types";
import styles from "./VerifySubEntityPopUp.module.css";

import Header from "./Verify_Header.svg";
import VerifiedIcon from "./Verified_Icon.svg";

import { Button } from "../components/Button/Button";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useAccount } from "../utils/AccountInfoContext";
import { useTranslation } from "react-i18next";

/**
 * Opens a pop up to verify phone numbers/emails
 */

export function VerifySubEntityPopUp({}) {
  const { t } = useTranslation();
  const history = useHistory();

  const { nagScreenData } = useAccount();

  const [entities, setEntities] = useState([]);

  useEffect(() => {
    if (nagScreenData && nagScreenData[0] !== undefined) {
      let entityArray = [];
      nagScreenData.map((entity, index) => {
        let entityToAdd = {
          email: entity.email,
          title: entity.name,
          address: entity.address,
          bankInfo: entity.bankInfo,
        };
        entityArray.push(entityToAdd);
      });
      setEntities(entityArray);
    }
  }, [nagScreenData]);

  const goBackToReferrerIfExists = async () => {
    let _prevUrl = document.referrer;

    if (
      _prevUrl &&
      !_prevUrl.includes("settings") &&
      !_prevUrl.includes("apps-dev.wwdb.com") &&
      !_prevUrl.includes("apps-staging.wwdb.com") &&
      !_prevUrl.includes("wwdb.com")
    ) {
      window.location.assign(_prevUrl);
    } else {
      history.push("/platinum-settings");
    }
  };

  const handleVerify = async (index) => {
    history.push("/platinum-settings");
  };

  const handleSkip = () => {
    goBackToReferrerIfExists();
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.btnHeader}>
          <Button
            className={styles.btnBack}
            buttonText={t("Skip")}
            onClick={() => handleSkip()}
          />
        </div>
        <div className={styles.image}>
          <img src={Header} alt="Verify Icon" />
        </div>
        <div className={styles.header}>{t("Let's Verify")}</div>
        <div className={styles.message}>
          {t("Every Year we ask for info for any legal entity")}
        </div>
        <div className={styles.subMessage}>
          {t("The following is entity requiring review")}
        </div>
        {entities.map((entity, index) => (
          <div className={styles.entityContainer} key={index}>
            <div className={styles.entityHeader}>
              <span className={styles.title}>{entity.title}</span>
            </div>
            <div className={styles.divider} />
            <div className={styles.content}>
              <div className={styles.leftContent}>
                <div className={styles.email}>{entity.email}</div>
                <div className={styles.address}>
                  <div className={styles.address1}>{entity.address.line1}</div>
                  <div className={styles.address2}>
                    {entity.address.city}
                    {", "}
                    {entity.address.state} {entity.address.line2}
                  </div>
                </div>
              </div>
              <div className={styles.rightContent}>
                <div className={styles.bankDetailsHeader}>
                  {t("Bank Details")}
                </div>
                <div className={styles.bankDetailsInfo}>
                  <div>
                    {entity.bankInfo
                      ? entity.bankInfo.bankName +
                        t("Ending in") +
                        entity.bankInfo.lastFour
                      : t("Bank Info Not Given")}
                  </div>
                  <div>{entity.bankInfo && entity.bankInfo.nameOnAccount}</div>
                </div>
              </div>
            </div>
            <div className={styles.divider} />
            <div
              onClick={() => handleVerify(index)}
              className={styles.startVerificationBtn}
            >
              {t("Start Verification")}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

VerifySubEntityPopUp.propTypes = {
  /**
   * Function called to close pop up
   */
  onClose: PropTypes.func,
  /**
   * Bool to determine if pop up is opened
   */
  isOpen: PropTypes.bool,
  /**
   * Function called when verify is clicked
   */
  onVerify: PropTypes.func,
};
